import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toast-container position-fixed bottom-0 end-0 p-3"
}
const _hoisted_2 = {
  id: "liveToast",
  class: "toast hide",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true"
}
const _hoisted_3 = { class: "toast-body fs-md-15 fs-lg-16 text-paragraph lh-base" }
const _hoisted_4 = {
  key: 1,
  class: "footer-area text-center text-md-start bg-white ps-15 pe-15 pt-20 pb-20 ps-md-40 pe-md-40 pt-md-25 pb-md-25"
}
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-md-6 col-lg-6" }
const _hoisted_7 = { class: "text-body-secondary fw-medium mb-0" }

import stateStore from "../../utils/store";
import {ref, onMounted,onBeforeMount,reactive,inject} from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const stateStoreInstance = stateStore;
const { t } = useI18n();
// let message: string|null = localStorage.getItem('message');
let message=ref(localStorage.getItem('message'));
// alert(message.value);

// const showToast = () => {
//   const toastElement = document.getElementById("liveToast");
//   if (toastElement) {
//     const toastBootstrap = new window.bootstrap.Toast(toastElement);
//     toastBootstrap.show();
//   }
// };
// onMounted(() => {
//   stateStoreInstance.show = false;
//   if (typeof window.bootstrap === "undefined") {
//     const script = document.createElement("script");
//     script.src =
//       "https://cdn.jsdelivr.net/npm/bootstrap@5/dist/js/bootstrap.bundle.min.js";
//     script.onload = () => {
//       if(message.value!==null){
//         showToast();
//       }      
//     };
//     document.head.appendChild(script);
//   }
// });

// export default {
//   name: "MainFooter",
//   setup() {
//     const stateStoreInstance = stateStore;
//     return {
//       stateStoreInstance,
//     };
//   },
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
    (_unref(message)!==null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "toast-header" }, [
              _createElementVNode("svg", {
                class: "rounded me-2",
                width: "20",
                height: "20",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false"
              }, [
                _createElementVNode("rect", {
                  width: "100%",
                  height: "100%",
                  fill: "#726eed"
                })
              ]),
              _createElementVNode("strong", { class: "me-auto text-black" }, "Notification"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "data-bs-dismiss": "toast",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(message)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(stateStoreInstance).show==true)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _cache[1] || (_cache[1] = _createTextVNode(" © ", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fw-bold text-primary" }, "Izypay", -1)),
                _createTextVNode(". " + _toDisplayString(_unref(t)('auth.allRightsReserved')) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("a", {
                  href: "https://imoney.africa/",
                  class: "text-decoration-none fw-bold transition",
                  target: "_blank"
                }, "I-MONEY", -1))
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-6 col-lg-6 text-md-end" }, [
              _createElementVNode("ul", { class: "footer-menu ps-0 mb-0 list-unstyled fw-medium" })
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})